import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchEntitlement } from '../../../../../store/actions/entitlementActions';
import { Btn } from '../../../../ForBrands/ui/BrandUI';
import { planRows } from '../coachProfileModel';
import { KeyValueCard, KeyValueRow, SectionHead } from '../coachProfilePieces';

const LOADING_ROWS = [{ label: 'Status' }, { label: 'Plan' }];

// Figma 04 · Subscription: the live plan from GET /entitlement/. Plans,
// checkout and the Stripe portal stay on /coach/billing. Phones get their
// own screen (PhoneSubscription in CoachProfilePhone, 2471:4187: the card,
// then a full-width 52px Manage billing), so this is the desktop section.
const SubscriptionSection = () => {
  const dispatch = useDispatch();
  const entitlement = useSelector((s) => s.entitlement) || {};
  const subscription = useSelector((s) => s.user.user?.subscription);

  useEffect(() => {
    // A failed load falls back to the account's own record below.
    Promise.resolve(dispatch(fetchEntitlement())).catch(() => {});
  }, [dispatch]);

  const rows = planRows(entitlement, subscription) || LOADING_ROWS;

  return (
    <>
      <SectionHead
        title="Subscription"
        right={
          <Btn variant="secondary" to="/coach/billing">
            Manage billing
          </Btn>
        }
      />
      <KeyValueCard>
        {rows.map((row) => (
          <KeyValueRow key={row.label} label={row.label}>
            {row.value ?? <span className="bm-body-m text-bm-muted">Loading…</span>}
          </KeyValueRow>
        ))}
      </KeyValueCard>
    </>
  );
};

export default SubscriptionSection;
